import Vue from 'vue';
import $eventBus from '../event-bus';

/* global _as_rest */
/* eslint camelcase: 0 */

// eslint-disable-next-line no-new
new Vue({
  el: '#as_confirmation',

  data: {
    order_state: {}
  },

  mounted() {
    $eventBus.$emit('mounted', this);
  },

  methods: {
    reset() {
      $eventBus.$emit('reset');

      setTimeout(() => {
        window.location.reload();
      }, 10);
    }
  }
});

